export const name = {
    'en': 'IFTTT',
    'zh-tw': 'IFTTT'
};

export const fetchIFTTT = {
    'en': 'IFTTT [key] send event [event] value1 [value1] value2 [value2] value3 [value3]',
    'zh-tw': 'IFTTT [key] 傳送事件 [event] 參數1 [value1] 參數2 [value2] 參數3 [value3]'
};
